import { nextTick } from 'vue';

export function useTabs(selectorForContainerMenu: string) {
  return {
    // Прокрутка в меню до активного элемента
    async scrollMenuToActiveElement() {
      // Ждем отрисовки DOM
      await nextTick();

      const container = document.querySelector<HTMLElement>(selectorForContainerMenu);

      if (!container) {
        return;
      }

      // Ищем активную ссылку
      const link = container.querySelector<HTMLElement>('.active');

      if (!link) {
        return;
      }

      // Прокрутка к активной ссылке
      if (container.scrollWidth > container.clientWidth) {
        container.scrollLeft = 0;

        await nextTick();

        container.scrollLeft = link.offsetLeft - container.offsetWidth + link.offsetWidth + 20;
      }
    },
  };
}
